<app-header></app-header>
 
<!-- Hero section -->
<owl-carousel-o [options]="customOptions" class="owl-btn-center-lr hero-slider-one" id="home">
    <ng-template carouselSlide *ngFor="let slide of slideStore">
        <!-- Slider Item -->
        <div class="section-fullscreen bg-dark-05 main-hero-section" style="background-image: url('{{slide.image}}')">
            <div class="bg-dark-05">
                <div class="container">
                    <div class="position-middle text-center">
                        <div class="row d-flex justify-content-center align-items-center">
                            <div class="col-12 col-lg-10 col-xl-10 col-md-10">
                                <h6 class="color-secondary h4 animated fadeInUp">{{slide.subtitle}}</h6>
                                <h1 class="text-white display-3 mb-4 animated fadeInRight">{{slide.title}}</h1>
                                <p class="mb-4 text-white fs-5 animated fadeInDown">{{slide.paragraph}}</p>
                                <a routerLink="/portfolio" class="me-2 px-4 py-sm-3 px-sm-5 btn btn-primary rounded-pill carousel-content-btn1 animated fadeInLeft">View Portfolio</a>
                                <a routerLink="/contact" class="ms-2 px-4 py-sm-3 px-sm-5 btn btn-primary rounded-pill carousel-content-btn2 animated fadeInRight">Get a Quote</a>
                            </div>
                        </div><!-- end row -->
                        
                    </div><!-- end row -->
                </div><!-- end container -->
            </div>
        </div>
    </ng-template>
</owl-carousel-o>
<!-- end owl-carousel -->

<!-- Fact Start -->
<div class="container-fluid bg-color-secondary py-5">
  <div class="container">
    <div class="row">
      
      <!-- Loop over facts array using *ngFor -->
      <div *ngFor="let fact of facts" class="col-lg-3">
        <div class="d-flex counter">
          <h1 class="me-3 color-dark counter-value">{{ fact.value }}</h1>
          <h5 class="text-white mt-1">{{ fact.label }}</h5>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- Fact End -->


<!-- About Start -->
<div class="container-fluid py-5 my-5">
    <div class="container pt-5">
        <div class="row g-5">
            <div class="col-lg-5 col-md-6 col-sm-12">
                <div class="h-100 position-relative">
                    <img src="assets/images/about-1.jpg" class="img-fluid w-75 rounded" alt="about-1" style="margin-bottom: 25%;">
                    <div class="position-absolute w-75" style="top: 25%; left: 25%;">
                        <img src="assets/images/about-2.jpg" class="img-fluid w-100 rounded" alt="about-2">
                    </div>
                </div>
            </div>
            <div class="col-lg-7 col-md-6 col-sm-12">
                <h5 class="color-primary">About Us</h5>
                <h1 class="mb-4">Creative Agency That Brings Your Vision to Life</h1>
                <p>We are a passionate team of designers, developers, and strategists dedicated to building unforgettable digital
                    experiences. From brand identity to web design, we turn your bold ideas into creative realities.</p>
                <p class="mb-4">Our mission is to help brands stand out in a crowded digital world by delivering custom solutions
                    that are innovative, impactful, and visually stunning. Let's shape your story with style and purpose.</p>
                <a routerLink="/about-us" class="btn btn-secondary rounded-pill px-5 py-3 text-white">Discover More</a>
            </div>
        </div>
    </div>
</div>
<!-- About End -->

<!-- Services Start -->
<div class="container-fluid services py-5 mb-5">
  <div class="container">
    <div class="text-center mx-auto pb-5 wow fadeIn" data-wow-delay=".3s" style="max-width: 600px;">
      <h5 class="color-primary">Our Services</h5>
      <h1>Design, Strategy & Technology Aligned for Your Success</h1>
    </div>
    
    <div class="row g-5 services-inner">
      
      <!-- Loop over services array using *ngFor -->
      <div *ngFor="let service of services" class="col-md-6 col-lg-4 wow fadeIn" [attr.data-wow-delay]="service.delay">
        
        <div class="services-item bg-light">
          <div class="p-4 text-center services-content">
            <div class="services-content-icon">
              <i [class]="service.icon + ' fa-7x mb-4 color-primary'"></i>
              <h4 class="mb-3">{{ service.title }}</h4>
              <p class="mb-4">{{ service.description }}</p>
              <a [routerLink]="service.link" class="btn btn-secondary text-white px-5 py-3 rounded-pill">Read More</a>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
<!-- Services End -->

<!-- Portfolio Start -->
<div class="container-fluid project py-5 mb-5">
  <div class="container">
    <div class="text-center mx-auto pb-5" style="max-width: 600px;">
      <h5 class="color-primary">Our Portfolio</h5>
      <h1>Our Recently Completed Projects</h1>
    </div>
    
    <div class="row g-5">
      
      <!-- Loop over projects array using *ngFor -->
      <div *ngFor="let project of projects" class="col-md-6 col-lg-4">
        
        <div class="project-item">
          <div class="project-img">
            <img [src]="project.image" class="img-fluid w-100 rounded" [alt]="project.title">
            <div class="project-content">
              <a [routerLink]="project.link" class="text-center">
                <h5 class="color-dark">{{ project.title }}</h5>
                <p class="m-0 text-white">{{ project.category }}</p>
              </a>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
<!-- Portfolio End -->

<!-- Blog Start -->
<div class="container-fluid blog py-5 mb-5">
  <div class="container">
    <div class="text-center mx-auto pb-5 wow fadeIn" data-wow-delay=".3s" style="max-width: 600px;">
      <h5 class="color-primary">Our Blog</h5>
      <h1>Latest Blog & News</h1>
    </div>
    
    <div class="row g-5 justify-content-center">
      
      <!-- Loop over blogs array using *ngFor -->
      <div *ngFor="let blog of blogs" class="col-lg-6 col-xl-4">
        
        <div class="blog-item position-relative bg-light rounded">
          <img [src]="blog.blogImage" class="img-fluid w-100 rounded-top" [alt]="blog.category">
          <span class="position-absolute px-4 py-3 bg-color-primary text-white rounded" style="top: -28px; right: 20px;">
            {{ blog.category }}
          </span>
          
          <div class="blog-btn d-flex justify-content-between position-relative px-3" style="margin-top: -75px;">
            <div class="blog-icon btn btn-secondary px-3 rounded-pill my-auto">
              <a [routerLink]="blog.link" class="btn text-white">Read More</a>
            </div>
            
            <div class="blog-btn-icon btn btn-secondary px-4 py-3 rounded-pill">
              <div class="blog-icon-1">
                <p class="text-white px-2">Share<i class="fa fa-arrow-right ms-3"></i></p>
              </div>
              <div class="blog-icon-2">
                <a href="#." class="btn me-1"><i class="fab fa-facebook-f text-white"></i></a>
                <a href="#." class="btn me-1"><i class="fab fa-x-twitter text-white"></i></a>
                <a href="#." class="btn me-1"><i class="fab fa-instagram text-white"></i></a>
              </div>
            </div>
          </div>
          
          <div class="blog-content text-center position-relative px-3" style="margin-top: -25px;">
            <img [src]="blog.authorImage" class="img-fluid rounded-circle border border-4 border-white mb-3" [alt]="blog.authorName">
            <h6>By {{ blog.authorName }}</h6>
            <span class="color-secondary">{{ blog.date }}</span>
            <p class="py-2">{{ blog.summary }}</p>
          </div>
          
          <div class="blog-coment d-flex justify-content-between px-4 py-2 border bg-color-primary rounded-bottom">
            <a href="#." class="text-white"><small><i class="fas fa-share me-2 color-secondary"></i>{{ blog.shares }} Share</small></a>
            <a href="#." class="text-white"><small><i class="fa fa-comments me-2 color-secondary"></i>{{ blog.comments }} Comments</small></a>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
<!-- Blog End -->

<!-- Team Start -->
<div class="container-fluid py-5 mb-5 team">
    <div class="container">
        <div class="text-center mx-auto pb-5" style="max-width: 600px;">
            <h5 class="color-primary">Our Team</h5>
            <h1>Meet our expert Team</h1>
        </div>
        <owl-carousel-o [options]="customOptionsTwo" class="owl-btn-center-lr team-carousel">
          <ng-template carouselSlide *ngFor="let slide of teamStore" [id]="slide.id">
            <div class="rounded team-item">
              <div class="team-content">
                <div class="team-img-icon">
        
                  <!-- Member Image -->
                  <div class="team-img rounded-circle">
                    <img [src]="slide.image" class="img-fluid w-100 rounded-circle" [alt]="slide.name">
                  </div>
        
                  <!-- Member Name & Designation -->
                  <div class="team-name text-center py-3">
                    <h4>{{ slide.name }}</h4>
                    <p class="m-0">{{ slide.designation }}</p>
                  </div>
        
                  <!-- Social Icons -->
                  <div class="team-icon d-flex justify-content-center pb-4">
                    <a *ngIf="slide.facebook" class="btn btn-square btn-secondary text-white rounded-circle m-1"
                      [href]="slide.facebook">
                      <i class="fab fa-facebook-f"></i>
                    </a>
                    <a *ngIf="slide.twitter" class="btn btn-square btn-secondary text-white rounded-circle m-1"
                      [href]="slide.twitter">
                      <i class="fab fa-x-twitter"></i>
                    </a>
                    <a *ngIf="slide.instagram" class="btn btn-square btn-secondary text-white rounded-circle m-1"
                      [href]="slide.instagram">
                      <i class="fab fa-instagram"></i>
                    </a>
                    <a *ngIf="slide.linkedin" class="btn btn-square btn-secondary text-white rounded-circle m-1"
                      [href]="slide.linkedin">
                      <i class="fab fa-linkedin-in"></i>
                    </a>
                  </div>
        
                </div>
              </div>
            </div>
          </ng-template>
        </owl-carousel-o>
    </div>
</div>
<!-- Team End -->

<!-- Testimonial Start -->
<div class="container-fluid testimonial py-5 mb-5">
  <div class="container">
    <div class="text-center mx-auto pb-5" style="max-width: 600px;">
      <h5 class="color-primary">Our Testimonial</h5>
      <h1>Our Client Saying!</h1>
    </div>
    
    <!-- Angular Owl Carousel Component -->
    <owl-carousel-o [options]="customOptionsThree" class="testimonial-carousel">
      <ng-template carouselSlide *ngFor="let item of testimonials" [id]="item.id">
        
        <div class="testimonial-item border p-4">
          <div class="d-flex align-items-center">
            
            <!-- Client Image -->
            <div>
              <img [src]="item.image" [alt]="item.name" class="img-fluid rounded-circle">
            </div>
            
            <!-- Client Details & Rating -->
            <div class="ms-4">
              <h5 class="color-secondary">{{ item.name }}</h5>
              <p class="m-0 pb-3">{{ item.profession }}</p>

              <!-- Dynamic Star Ratings -->
              <div class="d-flex pe-5">
                <i *ngFor="let star of getStars(item.rating)" class="fas fa-star me-1 color-primary"></i>
              </div>
            </div>

          </div>
          
          <!-- Testimonial Comment -->
          <div class="border-top mt-4 pt-3">
            <p class="mb-0">{{ item.comment }}</p>
          </div>
        </div>

      </ng-template>
    </owl-carousel-o>

  </div>
</div>
<!-- Testimonial End -->

<!-- Contact Start -->
<div class="container-fluid py-5 mb-5">
  <div class="container">
    <div class="text-center mx-auto pb-5 wow fadeIn" data-wow-delay=".3s" style="max-width: 600px;">
      <h5 class="color-primary">Get In Touch</h5>
      <h1 class="mb-3">Contact Us</h1>
    </div>

    <div class="contact-detail position-relative p-5">
      
      <!-- Contact Info Cards Loop -->
      <div class="row g-5 mb-5 justify-content-center">
        <div *ngFor="let item of contactDetails" class="col-xl-4 col-lg-6">
          
          <div class="d-flex bg-light p-3 rounded">
            <div class="flex-shrink-0 btn-square bg-color-secondary rounded-circle" style="width: 64px; height: 64px;">
              <i [class]="item.icon + ' text-white'"></i>
            </div>
            <div class="ms-3">
              <h6 class="color-dark">{{ item.title }}</h6>
              <a [href]="item.link" class="h6" target="_blank">{{ item.value }}</a>
            </div>
          </div>

        </div>
      </div>

      <!-- Map & Form Row -->
      <div class="row g-5">
        
        <!-- Google Map iframe -->
        <div class="col-lg-6 wow fadeIn" data-wow-delay=".3s">
          <div class="p-5 h-100 rounded contact-map">
            <iframe 
              class="rounded w-100 h-100" 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3025.4710403339755!2d-73.82241512404069!3d40.685622471397615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c26749046ee14f%3A0xea672968476d962c!2s123rd%20St%2C%20Queens%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1686493221834!5m2!1sen!2sbd" 
              style="border:0;" 
              allowfullscreen="" 
              loading="lazy" 
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>

        <!-- Contact Form (Reactive Form) -->
        <div class="col-lg-6 wow fadeIn" data-wow-delay=".5s">
          <div class="p-5 rounded contact-form">
            <form (submit)="sendEmail($event)" #contactForm="ngForm">
              
              <div class="row gx-3 gy-0">
                
                <!-- Name Field -->
                <div class="col-12">
                  <div class="form-group mb-3">
                      <label class="visually-hidden" for="user_name">Name</label>
                      <input class="form-control" type="text" minlength="2" maxlength="15"
                          [class.is-invalid]="userName.invalid && userName.touched" name="user_name" id="name"
                          placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                      <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                          Name is required.
                      </div>
                  </div>
                </div>

                <!-- Email Field -->
                <div class="col-12">
                  <div class="form-group mb-3">
                      <label class="visually-hidden" for="user_email">Email</label>
                      <input class="form-control" type="email" minlength="2" maxlength="35"
                          [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email"
                          id="email" placeholder="Email *" [(ngModel)]="formData.user_email" #userEmail="ngModel" required
                          email>
                      <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                          A valid email is required.
                      </div>
                  </div>
                </div>

              </div>

              <!-- Message Field -->
              <div class="form-group mb-3">
                  <label class="visually-hidden" for="message">Project Details</label>
                  <textarea class="form-control" name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched"
                      id="message" rows="7" placeholder="Project Details" [(ngModel)]="formData.message"
                      #userMessage="ngModel" required></textarea>
                  <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                      Project details are required.
                  </div>
              </div>

              <div class="text-right">
                  <button type="submit" name="submit" class="btn btn-dark text-white py-3 px-5 mt-3"
                      [disabled]="contactForm.invalid" value="Send Mail">Send Mail</button>
              </div>
              
            </form>
            <div class="messages mrt-20 text-center"></div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
<!-- Contact End -->
